if (!customElements.get('media-gallery')) { 
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
      constructor() {
        super();
       
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="images-slider"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          autoheight: this.querySelector('[id^="images-slider"]')?.dataset.autoheight === "true",
          thumbnailOffset:0,
        } 

        
        if(!this.elements.viewer) return
        this.elements.viewer.addEventListener('load', () => {
          if (this.elements.autoheight && this.elements.viewer) {
              this.updateHeight(this.elements.viewer, 1 * this.elements.viewer.firstElementChild.dataset.height, 1 * this.elements.viewer.firstElementChild.dataset.width);
          }
          if (this.elements.autoheight && this.elements.viewer && this.elements.viewer.getAttribute("data-desktop-type") !== "slider" && window.innerWidth >= 850) {
              this.updateHeight(this.elements.viewer, null, null, true);
          }
        });
        
        
        let timer = null;
        this.elements.viewer.addEventListener('scroll', ()=> {
            if(timer !== null) {
                clearTimeout(timer);        
            }
            timer = setTimeout(()=>{
               this.onViewerChanged();
            }, 150);
        }, false);

        window.addEventListener('resize',()=>{
          if(window.innerWidth >= 850 && this.elements.viewer.getAttribute("data-desktop-type") !== "slider"){
             this.updateHeight(this.elements.viewer,null,null,true);
          }
          if(window.innerWidth < 850){
            this.updateHeight(this.elements.viewer,1 * this.elements.viewer.firstElementChild.dataset.height,1 * this.elements.viewer.firstElementChild.dataset.width)
          }
          offset = this.elements.viewer.firstElementChild.getBoundingClientRect().width;
        });
        
        if (!this.elements.thumbnails) return;
        this.elements.thumbnails.firstElementChild.classList.add('active');
        let offset = this.elements.viewer.firstElementChild.getBoundingClientRect().width;
        
        
        
        this.thumbnailOffset = this.elements.thumbnails.firstElementChild.getBoundingClientRect().width;
        Array.from(this.elements.thumbnails.getElementsByClassName('thumbnail')).forEach(thumbnail=>{
            let index = thumbnail.getAttribute('data-skip') * 1;
            thumbnail.addEventListener('click' , event => this.onThumbnailChanged(event,offset,index))
            this.elements.thumbnails.style.opacity = 1
        })
        
      }

      onThumbnailChanged(event,offset,index) {
        const targetImage = this.elements.viewer.querySelector(`[data-image="${index}"]`);
        if (targetImage) {
           targetImage.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: "center"
          }); 
        }

      }
      
      onViewerChanged(){
        let slider_start = this.elements.viewer.getBoundingClientRect().x;
        Array.from(this.elements.viewer.children).forEach(ele=>{
           if(ele.dataset.image && Math.abs(ele.getBoundingClientRect().x - slider_start) <= 10){
              const ele_att = ele.getAttribute('data-image') * 1;
        
              const selected = this.elements.viewer.querySelector(`[data-image='${ele_att}']`);
              if(this.elements.autoheight && selected){
                if(this.elements.viewer.getAttribute("data-desktop-type") === "slider" || window.innerWidth <= 850){
                   this.updateHeight(this.elements.viewer, selected.dataset.height, selected.dataset.width);  
                }
              }
              if (!this.elements.thumbnails) return;
              const thum = this.elements.thumbnails.querySelector(`[data-skip="${ele_att}"]`);
              this.setActiveThumbnail(thum,ele_att);
           }
        }) 
      }

      updateHeight(viewer,height,width,auto=false){
          if(auto) {
            return viewer.style.height = "auto"
          }else{
            return viewer.style.height = `${viewer.offsetWidth * height / width }px`;
          }
      }

      setActiveThumbnail(thumbnail,index) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('.thumbnail').forEach(ele=>{
            ele.classList.contains('active') && ele.classList.remove('active');
        })
        thumbnail.classList.add('active');
        let scrollBy = ((this.thumbnailOffset * index ) - this.thumbnailOffset) - (this.elements.thumbnails.getBoundingClientRect().width / 2  - this.thumbnailOffset / 2 );
        this.elements.thumbnails.scrollTo({ left: scrollBy, behavior: 'smooth'  });
      }
    });
} 
 

        /* const targetImage = this.elements.thumbnails.querySelector(`[data-skip="${index}"]`);
        const sliderLeft = this.elements.thumbnails.getBoundingClientRect().left;
        const targetRect = targetImage.getBoundingClientRect();
        const scrollX = targetRect.left; */
        /* if (targetImage) {
           targetImage.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: "center"
          });  */

          /* this.elements.thumbnails.scrollBy({
                 left: scrollX - sliderLeft ,
                 behavior: "smooth"
              })  
        }*/